import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoginFailedRouteService {
  public getLoginFailedRoute() {
    /* router is not working. Get current url from window.location */
    if (window.location.pathname.includes('co2')) {
      return '/co2/karte';
    }
    return '/karte';
  }
}
